import React from 'react';

import { MCButton, Spinner, FileBox, View, MCText } from 'src/components/basic';
import { popupModel } from 'src/components/complex';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import AddFeedback from 'src/components/treatments/AddFeedback';

import { lang, remCss, userFullName, permissions, addressObject } from 'src/helpers';

import { MediaGroup } from 'src/components/complex/MediaGroup';
import LANG_CONST from 'src/helpers/lang/const';

export const TreatmentFullDetail = ({ treatment, RightComp, LeftComp, model, onBack }) => {
  const { data, hospital, clinicId, hospitalId } = treatment || {};
  const { feedback } = data || {};

  const locationClinic = [];

  if (clinicId) locationClinic.push(userFullName(treatment.clinic));
  if (hospital)
    locationClinic.push(
      hospital.hospital?.split('_')[0] +
        ' ' +
        addressObject({
          cityAddress: hospital.city,
          stateAddress: hospital.state,
          countryAddress: hospital.country
        }).fullAddressNameReverse
    );
  else if (hospitalId === 'virtual') locationClinic.push(lang.t(LANG_CONST.virtual));

  if (!locationClinic.length) locationClinic.push(lang.t(LANG_CONST.independent));

  return (
    <div className={'mc-container-content mc-treatment-detail'}>
      <div className={'mc-container-content__header mc-flex-15'}>
        <div className={'mc-no-style-btn'} style={{ height: remCss(40) }} onClick={onBack}>
          <SVGIcon width={40} iconname={'back-icon'} />
        </div>
        <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.treatment_detail)}</span>
      </div>
      {!treatment ? (
        <div className={'mc-flex'}>
          <Spinner />
        </div>
      ) : (
        <div className={'mc-container-content__body horizontal'}>
          <RightComp />
          <div className={'mc-grow mc-p25 mc-flex-20-col'} style={{ overflow: 'auto' }}>
            <div className={'mc-flex-15-col mc-b2b mc-pb20'}>
              <div className={'mc-value-416'}>{lang.t(LANG_CONST.diagnosis)}</div>
              <div className={'mc-value-626'}>{data.diagnosis}</div>
              {data.description && <pre className={'mc-grow mc-label-418'}>{data.description}</pre>}
            </div>
            {data?.tagRecommendations?.length > 0 && (
              <div className={'mc-flex-20-col mc-bb mc-pb20'}>
                <div className={'mc-value-618'}>{lang.t(LANG_CONST.recommendations)}</div>
                {data?.tagRecommendations?.map((item, i) => (
                  <View key={'tag-recommendation-' + i} style={{ gap: remCss(10) }}>
                    <pre className={'mc-value-418'}>{item.text}</pre>
                    <div className={'mc-flex mc-wrap'}>
                      {item.tags.map((tag) => (
                        <MCButton
                          quaternary
                          small
                          rounded
                          light
                          style={{
                            paddingHorizontal: remCss(12),
                            paddingVertical: remCss(8)
                          }}
                          key={i + tag}
                        >
                          {tag.trim()}
                        </MCButton>
                      ))}
                    </div>
                  </View>
                ))}
              </div>
            )}
            <div className={'mc-flex-5-col mc-bb mc-pb20'}>
              <div className={'mc-value-618'}>{lang.t(LANG_CONST.prescribe_medicine)}</div>
              <div className={'mc-flex mc-p10'}>
                <div className={'mc-grow mc-label-516'}>{lang.t(LANG_CONST.medicine)}</div>
                <div className={'mc-grow mc-label-516'}>{lang.t(LANG_CONST.dosage)}</div>
                <div className={'mc-grow mc-label-516'} style={{ maxWidth: remCss(150) }}>
                  {lang.t(LANG_CONST.duration)}
                </div>
              </div>
              {data.medicines.map((item, i) => (
                <div className={'mc-flex mc-p10 mc-medicine-row'} key={i}>
                  <div className={'mc-grow mc-value-418'}>{item.name}</div>
                  <div className={'mc-grow mc-value-418'}>
                    {item.times
                      .map(
                        (time) =>
                          item.doze + ' ' + lang.t(LANG_CONST.constants.medicine_times[time])
                      )
                      .join(', ') +
                      ' (' +
                      lang.t(LANG_CONST.constants.medicine_period[item.period]) +
                      ')'}
                  </div>
                  <div className={'mc-grow mc-value-418'} style={{ maxWidth: remCss(150) }}>
                    {lang.t(item.days > 1 ? LANG_CONST.amount_day : LANG_CONST.amount_days, {
                      amount: item.days
                    })}
                  </div>
                </div>
              ))}
            </div>
            {data.nextUpdateAmount > 0 && (
              <div className={'mc-flex-20 mc-bb mc-pb20'}>
                <div className={'mc-value-618'}>
                  {lang.t(LANG_CONST.next_treatment_in, {
                    amount: data.nextUpdateAmount,
                    unit: data.nextUpdateUnit
                  })}
                </div>
              </div>
            )}
            {/*{data.recommendations && (*/}
            {/*  <div className={'mc-flex-20-col mc-bb mc-pb20'}>*/}
            {/*    <div className={'mc-value-618'}>{lang.t(LANG_CONST.recommendations)}</div>*/}
            {/*    {data.recommendations.map((item, i) => (*/}
            {/*      <div className={'mc-flex-10-col'} key={i}>*/}
            {/*        <div className={'mc-grow mc-value-418'}>{item.type}</div>*/}
            {/*        <div className={'mc-grow mc-label-418'}>{item.detail}</div>*/}
            {/*      </div>*/}
            {/*    ))}*/}
            {/*  </div>*/}
            {/*)}*/}
            <div className={'mc-flex-20-col mc-bb mc-pb20'}>
              <div className={'mc-value-618'}>{lang.t(LANG_CONST.clinic_location)}</div>
              <pre className={'mc-grow mc-label-418'}>{locationClinic.join(' - ')}</pre>
            </div>
            {data.note && (
              <div className={'mc-flex-20-col mc-bb mc-pb20'}>
                <div className={'mc-value-618'}>{lang.t(LANG_CONST.note)}</div>
                <pre className={'mc-grow mc-label-418'}>{data.note}</pre>
              </div>
            )}
            {treatment.media?.length > 0 && (
              <div className={'mc-flex-20-col mc-bb mc-pb20'}>
                <div className={'mc-value-618'}>{lang.t(LANG_CONST.treatment_files)}</div>
                <div className='mc-flex-20-col'>
                  {treatment.media.map((file, index) => (
                    <View
                      style={{ flexDirection: 'row', gap: remCss(20) }}
                      key={'mc-media-' + index}
                    >
                      <FileBox
                        list={treatment.media}
                        file={file}
                        onClose={null}
                        styles={{ width: remCss(150), height: remCss(150) }}
                        onlyPreview={true}
                        showFileName={true}
                      />
                      <MCText label={file.description} size={18} heading />
                    </View>
                  ))}
                </div>
              </div>
            )}
            <div className={'mc-flex-20-col mc-pb20'}>
              <div className={'mc-flex'}>
                <div className={'mc-value-618 mc-grow'}>{lang.t(LANG_CONST.patient_feedback)}</div>
                {permissions.ACTIONS.TREATMENTS_FEEDBACK_BUTTON.isActive && (
                  <MCButton
                    light
                    radius
                    primary
                    medium
                    type={'button'}
                    onClick={() => {
                      popupModel.setActivePopup('add_feedback', {
                        active: true,
                        component: AddFeedback,
                        props: { model, feedback }
                      });
                    }}
                    iconname={BASE_ICONS.PERSONAL_INFORMATION}
                    label={
                      feedback ? LANG_CONST.buttons.edit_feedback : LANG_CONST.buttons.add_feedback
                    }
                  />
                )}
              </div>
              {feedback && (
                <>
                  <div className={'mc-flex-10-col'}>
                    <div className={'mc-grow mc-value-418'}>{lang.t(LANG_CONST.status)}</div>
                    <div className={'mc-grow mc-label-420'}>
                      {lang.t(LANG_CONST.constants.health_statuses[feedback.status])}
                    </div>
                  </div>
                  {feedback.isImproved && (
                    <div className={'mc-flex-10-col'}>
                      <div className={'mc-grow mc-value-418'}>
                        {lang.t(LANG_CONST.is_your_health_improved)}
                      </div>
                      <pre className={'mc-grow mc-label-420'}>{feedback.improvedComment}</pre>
                    </div>
                  )}
                  {feedback.isEffect && (
                    <div className={'mc-flex-10-col'}>
                      <div className={'mc-grow mc-value-418'}>
                        {lang.t(LANG_CONST.side_effects)}
                      </div>
                      <pre className={'mc-grow mc-label-420'}>{feedback.effectComment}</pre>
                    </div>
                  )}
                  {feedback.media.length > 0 && (
                    <MediaGroup images={feedback.media} template={2} length={4} />
                  )}
                </>
              )}
            </div>
          </div>
          <LeftComp />
        </div>
      )}
    </div>
  );
};
